/** Match the Ramps protocol consumed by MoonPay's Platform widget frame. */
export function readSignedWidgetMessage(data) {
    let message = data;
    if (typeof data === 'string') {
        try {
            message = JSON.parse(data);
        }
        catch {
            return failure('widget_invalid_message');
        }
    }
    if (!record(message))
        return {};
    if (message.type === 'MOONPAY_READY')
        return { event: { kind: 'ready' } };
    if (message.version !== 1 || message.appName !== 'ramps' || message.type !== 'request')
        return {};
    switch (message.action) {
        case '__handshake':
            return {
                reply: JSON.stringify({
                    version: 1,
                    appName: 'ramps',
                    moonpaySdk: true,
                    correlationId: message.correlationId,
                    type: 'resolve',
                    payload: { version: 1, appVersion: 1 },
                }),
            };
        case 'onReady':
            return { event: { kind: 'ready' } };
        case 'onClose':
            return { event: { kind: 'close' } };
        case 'onTransactionCreated':
        case 'onTransactionCompleted':
        case 'onTransactionFailed': {
            const payload = message.payload;
            if (!record(payload) ||
                typeof payload.id !== 'string' ||
                !payload.id ||
                typeof payload.status !== 'string')
                return failure('widget_invalid_transaction');
            const status = payload.status === 'completed' || payload.status === 'failed' ? payload.status : 'pending';
            return {
                event: {
                    kind: message.action === 'onTransactionCreated' ? 'transactionCreated' : 'complete',
                    payload: { transaction: { id: payload.id, status } },
                },
            };
        }
        default:
            return {};
    }
}
export function signedWidgetOrigin(url) {
    const parsed = new URL(url);
    if (parsed.origin !== 'https://platform.moonpay.com' ||
        parsed.pathname !== '/v2/buy' ||
        !parsed.searchParams.get('allowedIpAddress') ||
        !parsed.searchParams.get('signature'))
        throw new Error('onramp_hosted_url_invalid');
    return parsed.origin;
}
function record(value) {
    return typeof value === 'object' && value !== null && !Array.isArray(value);
}
function failure(message) {
    return { event: { kind: 'error', payload: { code: 'generic', message } } };
}
